import React from 'react';
import { useTranslation } from 'react-i18next';
import { PropTypes } from 'prop-types';
import { Close } from 'styled-icons/evaicons-solid';
import styled from 'styled-components';
import { palette } from '../../../system/styles/styles';
import { useJob } from '../../contexts/useJobs';

const ContainerMain = styled.main`
  background-color: transparent;
  font-family: ${palette.nereg};
  overflow-y: auto;
  display: grid;
  grid-template-columns: 100%;
  position: relative;
  width: 20vw;
  button {
    &:nth-child(1) {
      background: ${palette.white};
      padding: 0;
      margin: 0;
      margin-bottom: 20px;
      width: 100%;
    }
  }
  .resetButton {
    font-size: 16px;
    letter-spacing: 0.5px;
    width: 100%;
    color: ${palette.white};
    background-color: ${palette.blue};
    padding: 10px;
    border-radius: 10px;
    cursor: pointer;
  }
  .genFilter {
    display: grid;
    grid-gap: 10px;
    box-shadow: ${palette.lightBS};
    background-color: ${palette.white};
    padding: 16px;
    .select-Users {
      font-size: 1rem !important;
    }
    .header-title {
      display: flex;
      justify-content: flex-end;
      svg {
        cursor: pointer;
      }
    }
    label {
      font-family: ${palette.nereg};
      font-size: 14px;
    }
    select {
      box-sizing: border-box;
      border: 1px solid #d3d5d8;
      font-size: 1rem;
      padding: 10px;
      line-height: 1.7;
      border-radius: 4px;
      margin-bottom: 16px;
      width: 100%;
    }
  }
  select,
  button {
    border: none;
    &:focus,
    &:active {
      outline: none;
    }
  }
`;

const FiltrosJobs = (props) => {
  const { t } = useTranslation(['jobs']);

  const { closeGeneralPopper } = props;
  const optionStatus = [
    { name: t('All'), value: 'all' },
    { name: t('ActivePlural'), value: true },
    { name: t('PausedPlural'), value: false },
    // { name: t('ClosedPlural'), value: 'closed' },
  ];

  const optionDates = [
    { name: t('Predefined'), value: 'all' },
    { name: 'A - Z', value: 'asc' },
    { name: 'Z - A', value: 'des' },
    { name: t('Newer'), value: 'ascDate' },
    { name: t('Older'), value: 'desDate' },
  ];
  const { state, handleStatusFilterChange, reset } = useJob();

  return (
    <ContainerMain>
      <div className="genFilter">
        <section className="header-title">
          <Close color="#000" size={25} onClick={closeGeneralPopper} />
        </section>
        <label>{t('ShowVacancies')}:</label>
        <select name="selectStatus" value={state.selectStatus} id="" onChange={handleStatusFilterChange}>
          {optionStatus.map((type) => (
            <option value={type.value} key={type.value}>
              {type.name}
            </option>
          ))}
        </select>
        <label>{t('OrderBy')}:</label>
        <select name="selectDate" value={state.selectDate} id="" onChange={handleStatusFilterChange}>
          {optionDates.map((type) => (
            <option value={type.value} key={type.value}>
              {type.name}
            </option>
          ))}
        </select>
        <button type="button" className="resetButton" onClick={reset}>
          {t('Reset')}
        </button>
      </div>
    </ContainerMain>
  );
};

FiltrosJobs.propTypes = {
  className: PropTypes.string,
  users: PropTypes.arrayOf(PropTypes.object),
  closeGeneralPopper: PropTypes.func,
};

FiltrosJobs.defaultProps = {
  className: '',
  users: [],
  closeGeneralPopper: () => {},
};

export default FiltrosJobs;
